// App.jsx
import React, { useState, useEffect } from 'react';
import DonationCards from './components/DonationCards';
import DonationForm from './components/DonationForm';
import Guestbook from './components/Guestbook';
import Gallery from './components/Gallery';
import MemoryUploadForm from './components/MemoryUploadForm';
import AdminLogin from './components/AdminLogin';
import AdminPage from './components/AdminPage';
import ApprovalPanel from './components/ApprovalPanel';
import ContactForm from './components/ContactForm';
import Sidebar from './components/Sidebar';
import MemorialVideo from './components/MemorialVideo';
import Insta360YouTubeEmbed from './components/Insta360YouTubeEmbed'; // ← NEW
import './index.css';

function App() {
  const [adminMode, setAdminMode] = useState(false);
  const [adminUser, setAdminUser] = useState(null);
  const [activeSection, setActiveSection] = useState('welcome');

  // Persist admin login
  useEffect(() => {
    const user = window.localStorage.getItem('adminUser');
    if (user) setAdminUser(JSON.parse(user));
  }, []);
  useEffect(() => {
    if (adminUser) {
      window.localStorage.setItem('adminUser', JSON.stringify(adminUser));
    } else {
      window.localStorage.removeItem('adminUser');
    }
  }, [adminUser]);

  return (
    <div className="gradient-bg min-h-screen flex flex-col items-center">
      <div style={{ width: '100%', maxWidth: 1440, margin: '0 auto', paddingLeft: 16, paddingRight: 16 }}>
        <div className="sidebar-main">
          {/* Responsive navigation */}
          <Sidebar
            activeSection={activeSection}
            setActiveSection={setActiveSection}
            adminUser={adminUser}
            onAdminClick={() => setAdminMode(true)}
            onLogout={() => { setAdminUser(null); setAdminMode(false); }}
          />

          {/* MAIN CONTENT */}
          <main className="sidebar-content">
            {/* WELCOME PAGE */}
            {activeSection === 'welcome' && (
              <>
                <img
                  src="/Revision-5.png"
                  alt="In Loving Memory of Theyda"
                  className="hero-image"
                />
                <div className="header-columns">
                  <div className="header-text">
                    <p>
                      Thank you for visiting this page dedicated to celebrating the life of <strong>Shonelle Theyda Thach</strong>—a beloved wife, mother, daughter, sister, and friend.
                    </p>
                    <p>
                      Theyda touched so many lives with her kindness, strength, and unwavering spirit. Her smile could light up a room, and she always put her family and friends before herself. She leaves behind her loving husband and two young sons, who are navigating this unimaginable loss.
                    </p>
                    <p>
                      If you feel moved to help, please know that every contribution will go directly to Theyda’s husband and boys to help cover memorial expenses and to support them as they adjust to life without her. Your generosity—whether through a donation or a heartfelt message—means more to our family than words can express.
                    </p>
                    <p>
                      We invite you to share a memory, a message, or a note of encouragement in the guestbook below. Your kindness brings comfort and reminds us of the community that surrounded Theyda with love.
                    </p>
                  </div>
                  <div className="header-text khmer-text">
                    <p>
                      សូមអរគុណចំពោះការទស្សនាទំព័រនេះ ដែលឧទ្ទិសដើម្បីអបអរសាទរជីវិតរបស់ <strong>Shonelle Theyda Thach</strong>—ជាភរិយា មាតា កូនស្រី បងប្អូនស្រី និងមិត្តភក្តិដែលគ្រប់គ្នាស្រឡាញ់។
                    </p>
                    <p>
                      Theyda បានប៉ះពាល់ដល់ជីវិតរបស់មនុស្សជាច្រើន ដោយសេចក្តីអាណិតអាសូរ កម្លាំងចិត្ត និងវិញ្ញាណរឹងមាំរបស់នាង។ ផ្កាយចិត្តរបស់នាងអាចបំភ្លឺបន្ទប់មួយបាន ហើយនាងតែងដាក់គ្រួសារ និងមិត្តភក្តិក្នុងចិត្តមុនសព្វគ្នា។ នាងបានទុកឲ្យស្វាមី និងកូនប្រុសពីរនាក់ដែលកំពុងឆ្លងកាត់ភាពបាត់បង់ដ៏មិនអាចនឹកស្រមៃបាននេះ।
                    </p>
                    <p>
                      បើអ្នកមានចិត្តចង់ជួយ សូមជ្រាបថា ការចូលរួមរបស់អ្នកទាំងអស់នឹងទៅដល់ស្វាមី និងកូនប្រុសរបស់ Theyda ដើម្បីជួយគ្រប់គ្រងការចំណាយពិធីបុណ្យ និងគាំទ្រពួកគេនៅពេលដែលពួកគេកំពុងត្រូវប្ដូរជីវិតដោយគ្មាននាង។ ចិត្តសប្បុរសរបស់អ្នក មិនថាជាការបរិច្ចាគ ឬជាសារចិត្តល្អឡើយ មានអត្ថន័យយ៉ាងខ្លាំងសម្រាប់គ្រួសាររបស់យើង។
                    </p>
                    <p>
                      យើងសូមអញ្ជើញឱ្យអ្នកចែករំលែកអនុស្សាវរីយ៍ សារឬពាក្យលើកទឹកចិត្តក្នុងសៀវភៅភ្ញៀវខាងក្រោម។ ភាពអធ្យាស្រ័យ និងចិត្តសប្បុរសរបស់អ្នក គឺជាការលើកទឹកចិត្តដ៏អស្ចារ្យ ហើយជាការចងចាំថាភាពស្រឡាញ់របស់សហគមន៍នៅជុំវិញ Theyda មិនដែលអស់សព្វថ្ងៃទេ។
                    </p>
                  </div>
                </div>
              </>
            )}

            {/* OBITUARY PAGE */}
            {activeSection === 'obituary' && (
              <section className="obituary-section">
                <img
                  src="/Theyda-Khmer.jpg"
                  alt="In Loving Memory of Shonelle Theyda Thach"
                  className="obituary-photo"
                />
                <h2 className="obituary-title" style={{
                  fontFamily: "'Montserrat', Arial, sans-serif",
                  color: "#7c53c3",
                  fontSize: "2.3rem",
                  fontWeight: 800,
                  marginBottom: "1.3rem",
                  textAlign: "center"
                }}>
                  In Loving Memory<br/>Shonelle Theyda Thach
                </h2>
                <div className="obituary-text" style={{
                  background: "rgba(255,255,255,0.97)",
                  borderRadius: 18,
                  padding: "2rem 2.2rem",
                  maxWidth: 630,
                  margin: "0 auto",
                  fontSize: "1.18rem",
                  color: "#37245b",
                  fontFamily: "'Montserrat', Arial, sans-serif",
                  lineHeight: 1.75,
                  boxShadow: "0 4px 24px #bdb3e2aa"
                }}>
                  <p style={{ fontWeight: 600, color: "#8854e6" }}>
                    <span style={{ display: "inline-block", minWidth: 95 }}>Sunrise:</span> May 4, 1990<br />
                    <span style={{ display: "inline-block", minWidth: 95 }}>Sunset:</span> August 3, 2025
                  </p>
                  <p>
                    Shonelle Theyda Thach, 35, of Wichita, Kansas, passed away on August 3, 2025, surrounded by her loved ones. She was born on May 4, 1990, in Phoenix, Arizona.
                  </p>
                  <p>
                    Shonelle was the heart of every gathering - known for her radiant smile, infectious laughter, and magnetic personality. She loved cooking for her family, gardening in the sunshine, dancing to her favorite music, and creating joyful memories with everyone she touched. Her warmth, kindness, and ability to bring people together will never be forgotten.
                  </p>
                  <p>
                    She is survived by her devoted husband of 11 years, Veassna Chan, and their two beloved sons, Nolan and Nelson Chan; her parents, Phat Thach and Suzanne (Keam) Cruz; her stepfather, Garfield Cruz; and her brother, Tony Thach.
                  </p>
                  <p>
                    Shonelle also shared a deep and loving bond with her extended family, especially her in-laws, including Lena Chan Touch and Sam Touch and family, Phina Chan and Pinna Say and family, Noeu Chan and Kimberly Chan and family, and her dear friend and sister-in-law Amber Thach. She was also a beloved aunt to numerous nieces and nephews, including her great-niece, Sadie Shonelle Scott, who proudly carries her name.
                  </p>
                  <hr style={{ border: 0, borderTop: "1.5px solid #b79bfa", margin: "2rem 0" }}/>
                  <p>
                    <strong>Visitation:</strong> Friday, August 8, and Saturday, August 9, from 5:00 to 7:00 PM.<br/>
                    <strong>Funeral Service:</strong> Sunday, August 10, at 1:00 PM.<br/>
                    <span style={{ fontWeight: 600 }}>
                      All services will be held at Reflection Pointe Funeral & Cremation Services,<br/>
                      3201 S. Webb Rd., Wichita, KS 67210.
                    </span>
                  </p>
                  <p>
                    In lieu of flowers, donations may be made to support Shonelle’s family through the memorial site:<br/>
                    <a href="http://theyda.netlify.app" target="_blank" rel="noopener noreferrer" style={{ color: "#8854e6", fontWeight: 700, fontSize: "1.09rem" }}>
                      👉 http://theyda.netlify.app
                    </a>
                  </p>
                  <p style={{ color: "#7d62ac", fontStyle: "italic", marginTop: 24 }}>
                    The family would like to extend their heartfelt gratitude to the ICU team at KU Medical Center for the extraordinary care, compassion, and dignity they provided to Shonelle during her final days.
                  </p>
                </div>
              </section>
            )}

            {/* DONATION INFO PAGE */}
            {activeSection === 'donate' && (
              <>
                <h2 style={{ color: "#8854e6", marginBottom: 20, textAlign: 'center' }}>Ways to Support the Family</h2>
                <DonationCards />
              </>
            )}

            {/* FUNERAL & VISITATION INFO PAGE */}
            {activeSection === 'funeral' && (
              <>
                <h2 style={{ color: "#8854e6", marginBottom: 20, textAlign: 'center' }}>Funeral & Visitation Information</h2>
                <div style={{ background: "#f5f2ff", borderRadius: 12, padding: 24, maxWidth: 650, margin: "0 auto", fontSize: 18 }}>
                  <p><strong>Family & Friends Gathering:</strong> Tuesday - Friday, August 5th-8th, 5:00–10:00 PM<br />
                  Home of Veassna Chan & Shonelle Theyda Thach<br />
                  2318 S Chateau ST Wichita, KS  67207</p>
                  <p><strong>Buddhist Monk Chant - Bang Skaul:</strong> Saturday, August 9th, 7:00–9:00 PM<br />
                  Home of Veassna Chan & Shonelle Theyda Thach<br />
                  2318 S Chateau ST Wichita, KS  67207</p>
                  <p><strong>Visitation:</strong> Friday & Saturday, August 8th-9th, 5:00–7:00 PM<br />
                  Reflection Pointe Funeral and Cremation Services<br />
                  3201 South Webb Rd  Wichita, KS  67210</p>
                  <p><strong>Funeral Service:</strong> Sunday, August 10th, 1:00 PM<br />
                  Reflection Pointe Funeral and Cremation Services<br />
                  3201 South Webb Rd  Wichita, KS  67210</p>
                  <p>If you need more info or directions, please contact the family directly, or check back here for updates.</p>
                </div>
              </>
            )}

            {/* GALLERY PAGE */}
            {activeSection === 'gallery' && (
              <>
                <h2 className="gallery-title">Photo & Video Gallery</h2>
                <MemoryUploadForm />
                <Gallery />
              </>
            )}

            {/* GUESTBOOK PAGE */}
            {activeSection === 'guestbook' && (
              <>
                <h2 className="guestbook-title">Guestbook & Tributes</h2>
                <DonationForm />
                <Guestbook />
              </>
            )}

            {/* TRIBUTE VIDEO PAGE */}
            {activeSection === 'video' && (
              <div className="video-page-container">
                <MemorialVideo fileId="1smm04Kxa-m1TzJIn2SdKxSkSNZcJUGzl" />
              </div>
            )}

            {/* 360° VIDEO PAGE (YouTube) */}
            {activeSection === 'insta360' && (
              <div className="video-page-container">
                <Insta360YouTubeEmbed
                  videoId="hwlhu72Gy1c"
                  title="Theyda • 360° Moment"
                />
              </div>
            )}

            {/* CONTACT PAGE */}
            {activeSection === 'contact' && (
              <>
                <h2 className="guestbook-title">Contact Us</h2>
                <p style={{ textAlign: "center", marginBottom: 16 }}>
                  If you have questions or need to reach the family, please fill out the form below.
                </p>
                <ContactForm />
              </>
            )}

            {/* ADMIN: PENDING SUBMISSIONS */}
            {activeSection === 'pending' && adminUser && (
              <ApprovalPanel />
            )}
          </main>
        </div>
      </div>

      {/* Admin Modal */}
      {adminMode && !adminUser && (
        <div className="admin-modal">
          <AdminLogin
            onLogin={(user) => {
              setAdminUser(user || true);
              setAdminMode(false);
            }}
            onCancel={() => setAdminMode(false)}
          />
        </div>
      )}
    </div>
  );
}

export default App;
